import React, { useState, useRef, useEffect } from "react";

type Option = {
  value: string;
  label: string;
};

const options: Option[] = [
  { value: "https://g.co/gemini/share/af4862f823f9", label: "Commercial" },
  { value: "https://gemini.google.com/share/2d09d430f4fa", label: "Residential" },
  { value: "https://g.co/gemini/share/20dd4ba6d40c", label: "Meetings" },
];

export default function PopupSelect() {
  const [selected, setSelected] = useState<Option>(options[0]);
  const [open, setOpen] = useState(false);

  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="relative inline-block" ref={wrapperRef}>
      {/* Select Box */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-48 flex justify-between items-center bg-white border border-gray-300 px-4 py-2 rounded focus:outline-none blue-bg"
        type="button"
      >
        <span>Stories</span>
        <svg className="h-4 w-4 ml-2 text-gray-500" style={{color: "white"}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <div className="absolute z-10 mt-2 w-48 bg-white border border-gray-300 rounded shadow-lg">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => {
                setSelected(option);
                setOpen(false);
                window.open(
                  option.value,
                  "_blank",
                  "width=600,height=600,left=200,top=200,noopener,noreferrer"
                );
              }}
              className={`block w-full text-left px-4 py-2 hover:bg-gray-100 ${
                selected.value === option.value ? "bg-gray-100" : ""
              }`} style={{color: "black"}}
              type="button"
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}